"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSignUp = void 0;
var broprint_js_1 = require("@rajesh896/broprint.js");
var navigation_1 = require("next/navigation");
var react_1 = require("react");
var apps_shared_1 = require("@l2p/apps-shared");
var keys_1 = require("../keys");
var useMutation_1 = require("../useMutation");
var user_1 = require("../user");
var useSignUp = function (_a) {
    var _b = _a === void 0 ? {} : _a, successAction = _b.successAction, errorAction = _b.errorAction;
    var setAuthorized = (0, user_1.useSetAuthorized)();
    var searchParams = (0, navigation_1.useSearchParams)();
    var _c = (0, useMutation_1.useMutation)({
        successAction: function (data) {
            successAction === null || successAction === void 0 ? void 0 : successAction(data);
            setAuthorized(true);
            (0, apps_shared_1.gtagEvent)(apps_shared_1.GtagEvents.SIGNUP);
        },
        errorAction: errorAction,
        keysUpdate: [
            keys_1.USER,
            keys_1.BALANCE,
            keys_1.WITHDRAWAL_BALANCE,
            keys_1.USER_KYC,
            keys_1.MY_LEVEL_PROGRESS,
            keys_1.TOURNAMENTS,
            keys_1.TOURNAMENTS_CURRENT,
            keys_1.DEPOSIT_METHODS,
            keys_1.PAY_IN_PROFILE_METHODS,
            keys_1.BONUSES_BY_TYPE,
            keys_1.GET_RECENT_GAMES,
            keys_1.GET_FAVORITE_GAMES,
        ],
        path: keys_1.SIGN_UP,
    }), mutate = _c.mutate, isSubmitting = _c.isSubmitting, error = _c.error;
    var signUpnHandler = (0, react_1.useCallback)(function (args) { return __awaiter(void 0, void 0, void 0, function () {
        var fingerprint;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, broprint_js_1.getCurrentBrowserFingerPrint)()];
                case 1:
                    fingerprint = _a.sent();
                    return [4 /*yield*/, mutate(__assign(__assign({}, args), { headers: {
                                'visitor-id': fingerprint,
                            }, testEmail: !!searchParams.get('testEmail') || undefined }))];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [mutate, searchParams]);
    return (0, react_1.useMemo)(function () { return ({
        signUp: signUpnHandler,
        isSubmitting: isSubmitting,
        error: error,
    }); }, [signUpnHandler, isSubmitting, error]);
};
exports.useSignUp = useSignUp;
